var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @ts-nocheck
import JSZip from "jszip";
// import imagesExport from './ImagesExport'
import axios from "axios";
import { imgSrcPathHelper } from "../../utils/helper";
// Helper function to get access token
var getAccessToken = function () {
    return localStorage.getItem('accessToken');
};
var ZipDownload = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var zip, i, accessToken, headers, response, imageData, imageBlob, error_1, octIndex, octRep, accessToken, headers, response, octPdfData, octPdfBlob, error_2, zipData, link;
    var _c, _d;
    var imgData = _b.imgData, csvData = _b.csvData, subjectId = _b.subjectId, fileName = _b.fileName, retinADReports_fp = _b.retinADReports_fp;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                zip = new JSZip();
                i = 0;
                _e.label = 1;
            case 1:
                if (!(i < imgData.length)) return [3 /*break*/, 6];
                _e.label = 2;
            case 2:
                _e.trys.push([2, 4, , 5]);
                accessToken = getAccessToken();
                headers = {};
                // Add authorization header if token exists
                if (accessToken) {
                    headers['Authorization'] = "Bearer ".concat(accessToken);
                }
                return [4 /*yield*/, axios.get(imgData[i]['img'], {
                        responseType: "blob",
                        headers: headers,
                        // Handle 304 Not Modified case
                        validateStatus: function (status) {
                            return status < 400; // Accept all status codes less than 400
                        }
                    })];
            case 3:
                response = _e.sent();
                // Handle 304 case - use cached data or skip
                if (response.status === 304) {
                    console.warn("Image ".concat(i, " returned 304 Not Modified, skipping..."));
                    return [3 /*break*/, 5];
                }
                imageData = response.data;
                imageBlob = new Blob([imageData], { type: 'image/jpg' });
                zip.file("".concat(((_c = imgData[i]) === null || _c === void 0 ? void 0 : _c["original_name"]) ? "".concat((_d = imgData[i]) === null || _d === void 0 ? void 0 : _d["original_name"]) : "image_".concat(i)), imageBlob);
                return [3 /*break*/, 5];
            case 4:
                error_1 = _e.sent();
                console.error("Failed to fetch image ".concat(i, ":"), error_1);
                // Continue with next image instead of failing the entire process
                return [3 /*break*/, 5];
            case 5:
                i++;
                return [3 /*break*/, 1];
            case 6:
                // zip csv - with csv blob
                if (csvData) {
                    zip.file('subjectInfo.csv', csvData);
                }
                octIndex = 0;
                _e.label = 7;
            case 7:
                if (!(octIndex < retinADReports_fp.length)) return [3 /*break*/, 12];
                octRep = retinADReports_fp[octIndex];
                _e.label = 8;
            case 8:
                _e.trys.push([8, 10, , 11]);
                accessToken = getAccessToken();
                headers = {};
                // Add authorization header if token exists
                if (accessToken) {
                    headers['Authorization'] = "Bearer ".concat(accessToken);
                }
                return [4 /*yield*/, axios.get(imgSrcPathHelper(octRep), {
                        responseType: "blob",
                        headers: headers,
                        // Handle 304 Not Modified case
                        validateStatus: function (status) {
                            return status < 400; // Accept all status codes less than 400
                        }
                    })];
            case 9:
                response = _e.sent();
                // Handle 304 case - use cached data or skip
                if (response.status === 304) {
                    console.warn("OCT PDF ".concat(octIndex, " returned 304 Not Modified, skipping..."));
                    return [3 /*break*/, 11];
                }
                octPdfData = response.data;
                octPdfBlob = new Blob([octPdfData], { type: 'application/pdf' });
                zip.file("pdf_fp_".concat(octIndex, ".pdf"), octPdfBlob);
                return [3 /*break*/, 11];
            case 10:
                error_2 = _e.sent();
                console.error("Failed to fetch OCT PDF ".concat(octIndex, ":"), error_2);
                // Continue with next PDF instead of failing the entire process
                return [3 /*break*/, 11];
            case 11:
                octIndex++;
                return [3 /*break*/, 7];
            case 12: return [4 /*yield*/, zip.generateAsync({
                    type: "blob",
                    streamFiles: true,
                })];
            case 13:
                zipData = _e.sent();
                link = document.createElement("a");
                link.href = window.URL.createObjectURL(zipData);
                link.download = fileName ? fileName + ".zip" : "zip-folder.zip";
                link.click();
                return [2 /*return*/];
        }
    });
}); };
export default ZipDownload;
